/** @type {Map<string, { driverId: string; quote: string }>} */
export const markerDrivers = new Map();

/**
 * @param {string} key
 * @returns {{ driverId: string | null; description: string }}
 */
export function getCornerMeta(key) {
  const entry = markerDrivers.get(key);
  return {
    driverId: entry?.driverId ?? null,
    description: entry?.quote ?? '',  // 'description' kept as engine-internal name
  };
}

/**
 * @param {string} key
 * @param {string | null} driverId
 */
export function setCornerDriver(key, driverId) {
  const existing = markerDrivers.get(key);
  if (driverId) {
    markerDrivers.set(key, { driverId, quote: existing?.quote ?? '' });
  } else if (existing) {
    if (existing.quote) {
      markerDrivers.set(key, { driverId: '', quote: existing.quote });
    } else {
      markerDrivers.delete(key);
    }
  }
}

/**
 * @param {string} key
 * @param {string} text
 */
export function setCornerDescription(key, text) {
  const trimmed = text.trim();
  const existing = markerDrivers.get(key);
  if (trimmed) {
    markerDrivers.set(key, { driverId: existing?.driverId ?? '', quote: trimmed });
  } else if (existing?.driverId) {
    markerDrivers.set(key, { driverId: existing.driverId, quote: '' });
  } else {
    markerDrivers.delete(key);
  }
}

/**
 * @param {string} key
 */
export function clearCornerMeta(key) {
  markerDrivers.delete(key);
}

/**
 * @param {Record<string, { driverId: string; quote: string }> | undefined} md
 */
export function loadCornerMetaFromPreset(md) {
  markerDrivers.clear();
  if (!md || typeof md !== 'object') return;
  for (const [key, val] of Object.entries(md)) {
    if (val && typeof val === 'object') {
      markerDrivers.set(key, {
        driverId: String(val.driverId || ''),
        quote: String(val.quote || ''),
      });
    }
  }
}

/**
 * @returns {Record<string, { driverId: string; quote: string }>}
 */
export function exportCornerMetaForPreset() {
  return Object.fromEntries(
    Array.from(markerDrivers.entries()).map(([k, v]) => [k, { ...v }])
  );
}

/**
 * @param {string} driverId
 * @returns {string[]} corner keys that were cleared
 */
export function clearDriverFromAllCorners(driverId) {
  const cleared = [];
  for (const [key, entry] of markerDrivers.entries()) {
    if (entry.driverId === driverId) {
      if (entry.quote) {
        markerDrivers.set(key, { driverId: '', quote: entry.quote });
      } else {
        markerDrivers.delete(key);
      }
      cleared.push(key);
    }
  }
  return cleared;
}
